// v2/hooks/useAdminCustomers.js — /api/v2/admin/customers/
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, qs } from '../utils/api';

export default function useAdminCustomers(params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);
  const sorgu = qs(params);

  const yenile = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet(`/v2/admin/customers/${sorgu}`, { signal: ctrl.signal });
      if (ctrl.signal.aborted) return;
      if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Liste alınamadı');
      setData({
        ...veri,
        items: Array.isArray(veri.items) ? veri.items : [],
        groups: Array.isArray(veri.groups) ? veri.groups : [],
        summary: veri.summary || {},
      });
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      setError((e && e.message) || 'Liste alınamadı');
    } finally {
      if (!ctrl.signal.aborted) setLoading(false);
    }
  }, [sorgu]);

  useEffect(() => {
    yenile();
    return () => { if (abortRef.current) abortRef.current.abort(); };
  }, [yenile]);

  return { data, loading, error, yenile };
}
